var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.section
      ? _c(
          "div",
          {
            staticClass: "bg-white text-primary rounded-sm p-4 mb-4 shadow-md",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex flex-row items-center text-sm font-medium text-primary mb-2",
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "w-4 h-4 mr-1 fill-current",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      height: "24",
                      viewBox: "0 0 24 24",
                      width: "24",
                    },
                  },
                  [
                    _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "text-primary text-opacity-70" }, [
                  _vm._v("Currently on:"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-row items-center leading-tight" },
              [
                _vm.section.speaker && _vm.section.speaker.photo
                  ? _c("ImgixImage", {
                      staticClass: "lc-section-photo mr-2",
                      attrs: {
                        image: _vm.section.speaker.photo,
                        width: 40,
                        height: 40,
                        alt: _vm.section.speaker.name,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.section.speaker && !_vm.section.speaker.photo
                  ? _c("div", { staticClass: "lc-section-initials" }, [
                      _vm._v("\n        " + _vm._s(_vm.initials) + "\n      "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-base text-primary font-bold leading-6 mb-1",
                    },
                    [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _vm.subtitle
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "text-xs font-medium text-primary text-opacity-70",
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.subtitle) + "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.next
              ? _c(
                  "div",
                  {
                    staticClass:
                      "mt-4 pt-2 text-xs border-0 border-t border-solid border-primary border-opacity-25",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "text-primary text-opacity-50 font-medium",
                      },
                      [_vm._v("Coming up:")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "text-primary text-opacity-70 font-medium",
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.sectionTitle(_vm.next)) +
                            "\n      "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }